module.exports = __webpack_public_path__ + "static/media/affinity.038d3d8f.png";